module.exports = ":host{text-align:center}h2{text-transform:capitalize}\n"